<template>
  <v-app>
    <app-header/>

    <v-main>
      <router-view class="app-content" />
      <app-error :errors="errors" />
    </v-main>

    <v-footer
      v-if="shopID !== 0"
      dark
      class="keycolor"
    >
      <app-footer/>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AppHeader from './AppHeader'
import AppFooter from './AppFooter'
import AppError from '@/pages/App/AppError'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    AppError
  },
  metaInfo: {
    titleTemplate (title) {
      const titles = []
      if (title) {
        titles.push(title)
      }
      titles.push('ネッツトヨタ福岡')
      return titles.join(' | ')
    }
  },
  computed: {
    ...mapState({
      errors: state => state.pagestate.errors
    }),
    ...mapGetters('shop', [
      'shopID'
    ])
  }
}
</script>
